import { enums } from '..';

const shortResolutionFormatter = (
  resolution: enums.ETimeframes
): enums.EParsedTimeframes => {
  switch (resolution) {
    case enums.ETimeframes.second:
      return enums.EParsedTimeframes.second;
    case enums.ETimeframes.fiveSeconds:
      return enums.EParsedTimeframes.fiveSeconds;
    case enums.ETimeframes.tenSeconds:
      return enums.EParsedTimeframes.tenSeconds;
    case enums.ETimeframes.minute:
      return enums.EParsedTimeframes.minute;
    case enums.ETimeframes.threeMinutes:
      return enums.EParsedTimeframes.threeMinutes;
    case enums.ETimeframes.fiveMinutes:
      return enums.EParsedTimeframes.fiveMinutes;
    case enums.ETimeframes.fifteenMinutes:
      return enums.EParsedTimeframes.fifteenMinutes;
    case enums.ETimeframes.thirtyMinutes:
      return enums.EParsedTimeframes.thirtyMinutes;
    case enums.ETimeframes.hour:
      return enums.EParsedTimeframes.hour;
    case enums.ETimeframes.twoHours:
      return enums.EParsedTimeframes.twoHours;
    case enums.ETimeframes.fourHours:
      return enums.EParsedTimeframes.fourHours;
    case enums.ETimeframes.sixHours:
      return enums.EParsedTimeframes.sixHours;
    case enums.ETimeframes.eightHours:
      return enums.EParsedTimeframes.eightHours;
    case enums.ETimeframes.twelveHours:
      return enums.EParsedTimeframes.twelveHours;
    case enums.ETimeframes.day:
      return enums.EParsedTimeframes.day;
    case enums.ETimeframes.threeDays:
      return enums.EParsedTimeframes.threeDays;
    case enums.ETimeframes.week:
      return enums.EParsedTimeframes.week;
    case enums.ETimeframes.month:
      return enums.EParsedTimeframes.month;
    case enums.ETimeframes.year:
      return enums.EParsedTimeframes.year;
    default:
      return enums.EParsedTimeframes.hour;
  }
};

export { shortResolutionFormatter };
